export const T = {
  en_GB: {
    settings: "Settings",
    customInstruments: "Custom Instruments",
    description: "Manage your custom instruments",
    documentation: "Documentation",
  },
  nb_NO: {
    settings: "Innstillinger",
    customInstruments: "Egendefinerte instrumenter",
    description: "Administrer dine egendefinerte instrumenter.",
    documentation: "Dokumentasjon",
  },
} as const;
